import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyDrawerContent } from '@capital-access/firefly/components';
import { ImpersonationTermsComponent } from './impersonation-terms.component';

@Component({
  standalone: true,
  imports: [CommonLocalizationModule, ImpersonationTermsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ca-impersonation-terms-drawer',
  template: `
    <div class="mt-1" data-automation-id="mobile-legal-section" caLocalizationScope="navigation">
      <label class="form-label-top">{{ 'authorizeImpersonationLabel' | caLocalize }}:</label>
      <div data-automation-id="mobile-impersonation-terms" class="mt-1 terms-scroll body-70">
        <ca-impersonation-terms></ca-impersonation-terms>
      </div>
    </div>
  `
})
export class ImpersonationTermsDrawerComponent extends FireflyDrawerContent<void> {}
